import React from "react";
import P from "prop-types";

import { useLocation, useHistory } from "react-router-dom";
import { NavButton, NavButtonHighlighted } from "./styles";

export function NavLink({ rota, children, disabled, onClick }) {
  const location = useLocation();
  const { pathname } = location;
  const splitLocation = pathname.split("/");

  const history = useHistory();

  function handleClick() {
    history.push(rota);
    onClick();
  }

  let isInMainPage =
    splitLocation[1] === rota.pathname.split("/")[1] ? true : false;

  return (
    <>
    {splitLocation[1] === 'declaracao-de-privacidade' ? <></> : isInMainPage ? (
        <>
          <NavButtonHighlighted
            enabled={pathname === rota.pathname ? 0 : 1}
            onClick={() => {
              handleClick();
            }}
          >
            {children}
          </NavButtonHighlighted>
        </>
      ) : (
        <NavButton
          disabled={disabled}
          onClick={() => {
            handleClick(rota);
          }}
        >
          {children}
        </NavButton>
      )}
      
    </>
  );
}

NavLink.propTypes = {
  rota: P.shape({
    pathname: P.string.isRequired,
  }),
  disabled: P.bool.isRequired,
  children: P.node.isRequired,
};
